// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__9QW_-","select":"Header_select__2P_ux","clinic":"Header_clinic__1QjCE"};